import * as Choice from "../../../../src/Components/Modals/Choice/Choice.scss";
import { getMaterialIcon } from "../../../ViewUtils.js";
import * as react from "react";
import { modal, getModalFooterContainer } from "../../Modal/Modal.js";
import { modalMain, ButtonProps, defaultProps, modalCancel } from "../../Button/Button.js";


function renderHeader(header, onDecline) {
    let children_2, children, children_6, children_4;
    const children_10 = [(children_2 = [(children = [getMaterialIcon("close")], react.createElement("span", {
        className: "choice-icon",
        onClick: onDecline,
    }, ...children))], react.createElement("div", {
        className: "choice-container__close",
    }, ...children_2)), (children_6 = [(children_4 = [getMaterialIcon("error")], react.createElement("span", {
        className: "choice-icon",
    }, ...children_4))], react.createElement("div", {
        className: "choice-container__icon",
    }, ...children_6)), react.createElement("h1", {
        className: "choice__header",
    }, header)];
    return react.createElement("div", {
        className: "choice-container__header",
    }, ...children_10);
}

function renderBody(bodyHtml) {
    return react.createElement("div", {
        className: "choice-container__body",
    }, bodyHtml);
}

function renderButtons(declineButtonText, confirmButtonText, onDecline, onConfirm) {
    let children;
    return getModalFooterContainer((children = [modalCancel(new ButtonProps(declineButtonText, defaultProps.Content, onDecline, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)), modalMain(new ButtonProps(confirmButtonText, defaultProps.Content, onConfirm, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))], react.createElement(react.Fragment, {}, ...children)));
}

export function render(header, body, buttonDecline, buttonConfirm, onDecline, onConfirm) {
    const children = [renderHeader(header, onDecline), renderBody(body), renderButtons(buttonDecline, buttonConfirm, onDecline, onConfirm)];
    return react.createElement("div", {
        className: "choice-container",
    }, ...children);
}

export function renderModal(header, body, buttonDecline, buttonConfirm, onDecline, onConfirm) {
    return modal(true, render(header, body, buttonDecline, buttonConfirm, onDecline, onConfirm));
}

